// ── Modell-lista helperek (tiszta, tesztelhető) ──────────────────────────────
import { akkuArSzoveg } from '../constants/szervizArak';

// A szerviz-landingek (Samsung/Xiaomi akku, iPhone akku, …) modell-listája a
// felvásárló-kalkulátor adatbázisából épül. Ezek a függvények FALLBACK/live
// {brand:[model]} bemenetből dolgoznak – nincs hardcode, nincs adatduplikáció.

// Az oldal-szintű „…-tól” címke, amikor egy modellre nincs tételes árunk.
// A Samsung/Xiaomi landing ezt használja (arra nincs tételes árlistánk).
export const PRICE_FALLBACK = '13 000 Ft-tól';
export const XIAOMI_RE = /^(xiaomi|redmi|poco)/i;   // Xiaomi/Redmi/POCO modellnév-előtag
export const MESSENGER = 'https://m.me/NorbiPhone';

/** Egyedi + magyar ABC-sorrend. */
export const dedupeSort = (arr) =>
  [...new Set(arr)].sort((a, b) => a.localeCompare(b, 'hu'));

/** {brand:[model]} → Samsung + Xiaomi/Redmi/POCO megjelenítendő nevek. */
export const samsungXiaomiList = (src) => {
  if (!src) return [];
  const samsung = (src.Samsung || []).map((m) => `Samsung ${m}`);
  // Xiaomi/Redmi/POCO: bármely ilyen NEVŰ márka-kulcs összes modellje (pl. a
  // kalkulátor 'Xiaomi' márkája), PLUSZ bármely modell, amelynek neve
  // xiaomi/redmi/poco-val kezdődik (legacy catch-all márka biztonsági hálóként).
  const xiaomi = Object.entries(src).flatMap(([brand, list]) =>
    XIAOMI_RE.test(brand) ? (list || []) : (list || []).filter((m) => XIAOMI_RE.test(m)),
  );
  return dedupeSort([...samsung, ...xiaomi]);
};

/** {brand:[model]} → iPhone modellek. */
export const iphoneList = (src) => {
  if (!src) return [];
  return dedupeSort([...(src.iPhone || [])]);
};

/**
 * Egy modell megjelenítendő ára.
 *
 * KORÁBBAN ez minden modellre ugyanazt a „13 000 Ft-tól” szöveget adta – az
 * iPhone akkumulátor-landingen ezért MINDEN iPhone-ra 13 000 Ft állt, miközben
 * a /szerviz árlistája szerint a legolcsóbb iPhone akku 20 000 Ft. Élesben
 * derült ki: a valósnál ~40%-kal olcsóbb árat mutattunk a vevőnek.
 *
 * Most a KÖZÖS árlistából (constants/szervizArak.js) olvassuk. Ha arra a
 * modellre nincs tételes adat, a hívó oldal saját „…-tól” címkéje jön –
 * számot nem találunk ki.
 */
export const priceFor = (model, fallback = PRICE_FALLBACK) =>
  akkuArSzoveg(model) || fallback;

export const slugify = (s) =>
  (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');

/** „Ajánlatot kérek” → Messenger, a modellnév átadásával (ref). */
export const messengerFor = (model, kind = 'akku') =>
  `${MESSENGER}?ref=${encodeURIComponent(`${kind}_${slugify(model)}`).slice(0, 240)}`;

/** Felolvasható ajánlatkérő üzenet (title/SMS/e-mail fallbackhez). */
export const offerText = (model, serviceLabel = 'akkumulátorcserére') =>
  `Szeretnék ajánlatot kérni ${model} ${serviceLabel}.`;
